import React, { useEffect, useState } from "react";
import { X, Lightning } from "@phosphor-icons/react";
import LeadForm from "./LeadForm";
import { useLocation } from "react-router-dom";

export default function ExitIntentPopup() {
  const [show, setShow] = useState(false);
  const [shown, setShown] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (sessionStorage.getItem("orax_exit_shown")) return;
    const onMouseLeave = (e) => {
      if (e.clientY < 10 && !shown) {
        setShow(true);
        setShown(true);
        sessionStorage.setItem("orax_exit_shown", "1");
      }
    };
    // Delay showing on mobile scroll up
    let lastScrollY = window.scrollY;
    const onScroll = () => {
      const now = window.scrollY;
      if (now < lastScrollY - 100 && now < 200 && !shown && window.scrollY > 1000) {
        setShow(true);
        setShown(true);
        sessionStorage.setItem("orax_exit_shown", "1");
      }
      lastScrollY = now;
    };
    document.addEventListener("mouseleave", onMouseLeave);
    window.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("mouseleave", onMouseLeave);
      window.removeEventListener("scroll", onScroll);
    };
  }, [shown]);

  if (location.pathname.startsWith("/admin")) return null;
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="exit-popup">
      <div className="relative max-w-lg w-full bg-white rounded-3xl overflow-hidden shadow-2xl">
        <button
          onClick={() => setShow(false)}
          className="absolute top-4 right-4 w-10 h-10 rounded-full bg-[#F0EFEB] hover:bg-[#E5E3DB] flex items-center justify-center z-10"
          aria-label="Close"
          data-testid="exit-popup-close"
        >
          <X weight="bold" size={20}/>
        </button>
        <div className="bg-gradient-to-br from-[#135934] to-[#0A1F15] p-8 text-white">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#FDB813] text-[#0A1F15] text-xs font-bold mb-4">
            <Lightning weight="fill" size={14}/> LIMITED TIME SUBSIDY
          </div>
          <h2 className="font-display font-extrabold text-3xl leading-tight mb-2">
            Wait! Get ₹78,000 Subsidy
          </h2>
          <p className="text-white/85">
            Apply through Orax Solar and save up to ₹78,000 via PM Surya Ghar Yojana. Limited slots this quarter.
          </p>
        </div>
        <div className="p-6">
          <LeadForm source="exit-popup" compact />
        </div>
      </div>
    </div>
  );
}
